import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NoticiaPrensa } from 'src/app/home/_models/noticia-prensa';
import { GenericService } from 'src/app/_services/generic.service';
import { FiltroPrensaWeb } from 'src/app/home/_models/filtro-prensa-web';

@Injectable({
  providedIn: 'root'
})
export class PrensaWebService extends GenericService<PrensaWebService> {

  
  constructor(httpClient: HttpClient) {
    super(httpClient, 'PrensaWeb', 'v1');
  }

  getPrensaWeb(filtroPrensaWeb: FiltroPrensaWeb): Observable<NoticiaPrensa[]> {
    {
      return this._http.post<NoticiaPrensa[]>(`${this._apiCoreUrl}v1/PrensaWeb`, filtroPrensaWeb);
    }
  }
}
